import { keyBy } from "lodash";
import { parseCurrency, parseServerTimestampForClient } from "../../common/helpers";
import { format } from "date-fns";
import { DateFormat } from "utilities/dist/invoice/constants";
import { ProductLinkRenderer } from "../grid/cell-renderers.component";
import { ReferenceRenderer } from "./cell-renderers.component";

export const allHistoryColumns = keyBy(
    [
        {
            field: "inventory.distributor",
            headerName: "Distributor",
            editable: true,
            valueGetter: function ({ data }) {
                return !data ? null : data.inventory.distributor;
            },
        },
        {
            field: "inventory.product.upc",
            filter: "agTextColumnFilter",
            headerName: "UPC",
            valueGetter: function ({ data }) {
                return !data ? null : data?.inventory.product.upc;
            },
        },
        {
            field: "inventory.product.product",
            filter: "agTextColumnFilter",
            headerName: "Product",
            minWidth: 250,
            cellRenderer: ProductLinkRenderer,
            valueGetter: function ({ data }) {
                return !data ? null : data.inventory.product?.product;
            },
        },
        {
            field: "inventory.product.product_size",
            filter: "agTextColumnFilter",
            headerName: "Size",
            valueGetter: function ({ data }) {
                return !data ? null : data.inventory.product?.product_size;
            },
        },
        {
            field: "inventory.product.product_price",
            filter: "agTextColumnFilter",
            headerName: "Unit Price",
            headerTooltip: "Unit Price",
            valueGetter: function ({ data }) {
                return !data ? null : parseCurrency(data.inventory.product?.product_price);
            },
        },
        {
            field: "qty",
            headerName: "Qty",
            headerTooltip: "Adjusted Qty",
            editable: false,
            filter: "agNumberColumnFilter",
            valueGetter: function ({ data }) {
                return !data ? null : data.qty;
            },
        },
        {
            field: "source",
            headerName: "Source",
            headerTooltip: "Adjustment Source",
            editable: false,
            filter: "agTextColumnFilter",
            valueGetter: function ({ data }) {
                return !data ? null : data.source;
            },
        },
        {
            field: "ref",
            headerName: "Reference",
            headerTooltip: "Reference details for adjustment",
            editable: false,
            cellRenderer: ReferenceRenderer,
            valueGetter: function ({ data }) {
                return data ? data?.invoice || data?.ref_number || null : null;
            },
        },
        {
            field: "created_at",
            headerName: "Date",
            filter: "agDateColumnFilter",
            pinnedRowCellRenderer: () => null,
            headerTooltip: "Date of Adjustment",
            valueGetter: function ({ data }) {
                return !data
                    ? null
                    : format(parseServerTimestampForClient(data.created_at), DateFormat);
            },
        },
    ],
    "field"
);
